import React, { createContext } from 'react'

const CollegeContext = createContext()

export default CollegeContext